<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from 'vue'
import { usePreventPullToRefresh } from '@/app/Checkout/composables/usePreventPullToRefresh'
import CartVoucherBlock from '@/app/Checkout/components/common/CartVoucherBlock/index.vue'
import FreeSamplesBlock from "@/app/Checkout/components/common/FreeSamplesBlock/index.vue"

const mobileContainerRef = ref(null)
usePreventPullToRefresh(mobileContainerRef)
</script>
